import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { GYPSUM, KOALA } from 'HubStyleTokens/colors';
import EbxFeatureTableHeaderCell from '../feature-table/EbxFeatureTableHeaderCell';
import { useEffect, useState } from 'react';
import { breakpointValues } from 'pricing-pages-ui/js/constants/Breakpoints';
export const headerHeight = 155;
const stickyStyles = css(["position:fixed;top:0;width:100%;height:", ";z-index:100;"], () => `${headerHeight}px`);
const FullWidthContainer = styled.div.withConfig({
  displayName: "FeatureTableDropdownHeader__FullWidthContainer",
  componentId: "sc-1tf8bvr-0"
})(["", " position:fixed;left:0;background-color:", ";box-shadow:inset 0 4px 4px rgba(124,152,182,0.2);filter:drop-shadow(0 4px 4px rgba(124,152,182,0.2));"], stickyStyles, GYPSUM);
const DropdownHeaderTable = styled.table.withConfig({
  displayName: "FeatureTableDropdownHeader__DropdownHeaderTable",
  componentId: "sc-1tf8bvr-1"
})(["", " display:", ";table-layout:fixed;margin:0;border-spacing:0;max-width:1130px;@media (min-width:", "px) and (max-width:", "px){max-width:1008px;}@media (min-width:", "px) and (max-width:", "px){max-width:776px;}@media (min-width:", "px) and (max-width:", "px){max-width:650px;}@media (max-width:", "px){width:94%;}"], stickyStyles, ({
  visible
}) => visible ? 'table' : 'none', breakpointValues.sdMac, breakpointValues.sd - 1, breakpointValues.tablet, breakpointValues.sdMac - 1, breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpointValues.tabletPortrait - 1);
const THead = styled.thead.withConfig({
  displayName: "FeatureTableDropdownHeader__THead",
  componentId: "sc-1tf8bvr-2"
})(["position:relative;height:inherit;z-index:101;tr{display:table-row;vertical-align:bottom;}tr th:nth-child(1){width:50%;}tr th{border-right:1px solid ", ";}"], KOALA);

const FeatureTableDropdownHeader = ({
  levels,
  tableRef
}) => {
  const [showHeader, setShowHeader] = useState(false);

  const handleScroll = () => {
    if (tableRef && tableRef.current) {
      const tableRect = tableRef.current.getBoundingClientRect();
      const {
        top,
        bottom
      } = tableRect;
      const shouldShowHeader = !!(top <= 250 && bottom > 200);
      setShowHeader(shouldShowHeader);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(DropdownHeaderTable, {
    visible: showHeader,
    children: [/*#__PURE__*/_jsx(FullWidthContainer, {}), /*#__PURE__*/_jsx(THead, {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {}), levels.map(level => /*#__PURE__*/_jsx(EbxFeatureTableHeaderCell, {
          productLevel: level,
          numOfLevels: levels.length
        }, level))]
      })
    })]
  });
};

export default FeatureTableDropdownHeader;